import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ConfigProvider, Layout, theme } from "antd";
import LoginPage from "./Pages/LoginPage";
import VehicleConfigPage from "./Pages/VehicleConfigPage";
import UsersPage from "./Pages/UsersPage";
import CannyListPage from "./Pages/CannyListPage";
import FrimwareManager from "./Pages/FirmwareManagerPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HeaderComponent from "./Components/HeaderComponent";
import Sidebar from "./Components/Sidebar";
import RecordDataPage from "./Pages/RecordDataPage";
import SmartButtonPage from "./Pages/SmartButtonsPage";
import MobileNotificationPage from "./Pages/MobileNotificationPage";
import HomePage from "./Pages/HomePage";
import { BRAND_DARK, BRAND_YELLOW } from "./utils/brandTheme";

const { Sider, Content, Footer, Header } = Layout;

const queryClient = new QueryClient();

function MainLayout() {
  return (
    <Layout style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <Header style={{maxHeight: '64px', background: BRAND_DARK}}>
        <HeaderComponent />
      </Header>
      <Layout style={{ height: "calc(100vh - 64px)", width: "100%", overflow: "hidden" }}>
        <Sider
          width={250}
          collapsible
          style={{ height: "100%", overflow: "auto", background: BRAND_DARK }}
        >
          <Sidebar />
        </Sider>
        <Layout style={{ height: "100%", width: "100%", overflow: "hidden" }}>
          <Content style={{ height: "calc(100% - 48px)", width: "100%", overflow: "auto" }}>
            <Outlet />
          </Content>
          <Footer style={{ textAlign: "center", padding: 15, maxHeight: "48px", background: BRAND_DARK, color: BRAND_YELLOW }}>
            <span style={{ fontWeight: "bold" }}>LazerLamps Ltd</span>
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
}

const CannyWebApp: React.FC = () => (
  <ConfigProvider
    theme={{
      algorithm: [theme.defaultAlgorithm, theme.compactAlgorithm],
      token: {
        colorPrimary: BRAND_YELLOW,
        colorLink: BRAND_YELLOW,
        colorLinkHover: "#ffce3a",
      },
      components: {
        Layout: {
          headerBg: BRAND_DARK,
          siderBg: BRAND_DARK,
          footerBg: BRAND_DARK,
          triggerBg: BRAND_DARK,
          triggerColor: BRAND_YELLOW,
        },
        Menu: {
          darkItemBg: BRAND_DARK,
          darkSubMenuItemBg: BRAND_DARK,
          darkItemColor: "rgba(255, 255, 255, 0.85)",
          darkItemHoverColor: BRAND_YELLOW,
          darkItemSelectedBg: BRAND_YELLOW,
          darkItemSelectedColor: BRAND_DARK,
          subMenuItemSelectedColor: BRAND_YELLOW,
        },
        Button: {
          primaryColor: BRAND_DARK,
          primaryShadow: "none",
        },
      },
    }}
  >
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/vehicle_config" element={<VehicleConfigPage />} />
            <Route path="/user" element={<UsersPage />} />
            <Route path="/canny" element={<CannyListPage />} />
            <Route path="/firmware_manager" element={<FrimwareManager />} />
            <Route path="/record_data" element={<RecordDataPage />} />
            <Route path="/smart_buttons" element={<SmartButtonPage />} />
            <Route path="/mobile_notification" element={<MobileNotificationPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </ConfigProvider>
);

export default CannyWebApp;
